import csatGuard from './guards/csatGuard';
import jwtGuard from './guards/jwt.guard';
import originGuard from './guards/originGuard';
import pageReloadGuard from './guards/pageReloadGuard';
import selectUnitGuard from './guards/selectUnitGuard';
import pageConclusionCheckinGuard from './guards/pageConclusionCheckinGuard';
import dynatracePageIdentifierGuard from './guards/dynatracePageIdentifierGuard';

const guards = [
  csatGuard,
  jwtGuard,
  originGuard,
  pageReloadGuard,
  selectUnitGuard,
  pageConclusionCheckinGuard,
  dynatracePageIdentifierGuard,
];

export default guards;
